import { DataBox } from './DataBox'
import { baseDriverModel } from '../driverModel'
import { PageHeader } from './PageHeader'
import { AddDriverModal } from './addDriverModal'
import { EditDriverModal } from './editDriverModal'

export function BaseDriver() {
    const { addCarVisible, editCarVisible } = baseDriverModel()
    return (
        <>
            <PageHeader />
            <DataBox />
            {addCarVisible && <AddDriverModal />}
            {editCarVisible && <EditDriverModal />}
        </>
    )
}
